import { InjectionToken } from '@angular/core';

export interface IAppConfig {
  URL: string;
  URLVN: string;
  VnWebURL: string;
  GMapGeoURL: string;
}

// Configuration values for our app
export const AppConfig: IAppConfig = {
  // URL: '//localhost:51884/api/',
  URL: '//easyorderws.dksh.com/api/', //Production
  // URL: '//app-sg-cc-eosws01p.azurewebsites.net/api/', //Production
  // URL: '//app-sg-cc-easyorderdevws01d.azurewebsites.net/api/', // Development API URL
  // URL: '//app-sg-cc-easyorderstgws01q.azurewebsites.net/api/', // Staging API URL    

  URLVN: '//easyorderws.dksh.com/api/', //Production
  // URLVN: '//app-sg-cc-eosws01p.azurewebsites.net/api/', //Production
  // URLVN: '//app-sg-cc-easyorderdevws01d.azurewebsites.net/api/', // Development API URL
  // URLVN: '//app-sg-cc-easyorderstgws01q.azurewebsites.net/api/', // Staging API URL    

  VnWebURL:'easyorder.vnbizbox.com',

  GMapGeoURL: 'https://maps.googleapis.com/maps/api/geocode/json'
};

// Create a config token to avoid naming conflicts
export const APP_CONFIG = new InjectionToken<IAppConfig>('config');



// WEBPACK FOOTER //
// ./src/config/app-config.ts